<template>
  <v-container fluid class="white content-wrapper">
    <v-container grid-list-lg>
      <v-layout column>
        <v-flex
          class="display-2 font-weight-black heading--text text-center text-xs-center my-5"
          >Welcome to
        </v-flex>
        <v-flex>
          <div class="headline mt-3 text-center font-weight-bold">
            <img id="home-logo" src="../assets/logo-large.png" />
          </div>
        </v-flex>
        <v-flex>
          <div class="headline mt-3 heading--text text-center font-weight-bold">
            <a href="/sign-up">Click here NOW to sign up for Upload 2020</a>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      items: [
        {
          src: require('../assets/photos/upload-2013/2013-1.jpg')
        },
        {
          src: require('../assets/photos/upload-2013/2013-2.jpg')
        },
        {
          src: require('../assets/photos/upload-2013/2013-3.jpg')
        },
        {
          src: require('../assets/photos/upload-2013/2013-4.jpg')
        }
      ]
    };
  }
};
</script>

<style scoped>
.content-wrapper {
  margin-top: -10px;
  font-family: 'Lato', sans-serif;
  text-transform: uppercase;
}
.heading--text {
  color: #ff914d;
}
h1 {
  font-size: 20px;
}
video {
  width: 100%;
  height: auto;
}
a:link,
a {
  text-decoration: none;
  color: black !important;
}
a:hover {
  text-decoration: underline;
}

#home-logo {
  width: 75%;
}

@media screen and (min-width: 767px) {
  #home-logo {
    width: 40%;
  }
}
</style>
